var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "open-dv",
    on: {
      "click": _vm.handleClick,
      "touchstart": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "btn-bg"
  }), _c('div', {
    staticClass: "open-btn"
  }, [_c('div', {
    staticClass: "open-text",
    class: {
      'is-ios-title': _vm.isIPhone
    }
  }, [_vm._v(_vm._s('查看全文'))]), _c('div', {
    staticClass: "open-icon"
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };